import { useRoutes } from 'react-router-dom';
import { Suspense } from 'react';
import { routes } from './routers';
import Loading from './commons/components/Loading';

export default function AppRoutes() {
  const element = useRoutes(routes);

  return <Suspense fallback={<Loading fullScreen />}>{element}</Suspense>;
}
